module.exports = __webpack_public_path__ + "img/product_01.63b1d1c.webp";